/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Step2_DescInputs */

const en_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a job URL or description. Our AI rewrites your resume to match — keywords, formatting, and structure optimized for ATS.`)
};

const de_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuege eine Job-URL oder Beschreibung ein. Unsere KI schreibt deinen Lebenslauf um — Keywords, Format und Struktur ATS-optimiert.`)
};

const fr_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colle une URL d'offre ou une description. Notre IA réécrit ton CV pour correspondre — mots-clés, mise en forme et structure optimisés pour les ATS.`)
};

const es_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega la URL o la descripción del puesto. Nuestra IA reescribe tu currículum para que encaje — palabras clave, formato y estructura optimizados para ATS.`)
};

const it_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un URL o una descrizione dell'offerta. La nostra AI riscrive il tuo curriculum per corrispondere — parole chiave, formattazione e struttura ottimizzate per l'ATS.`)
};

const nl_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een vacature-URL of beschrijving. Onze AI herschrijft je CV zodat het past — zoekwoorden, opmaak en structuur geoptimaliseerd voor ATS.`)
};

const pl_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wklej link do oferty lub opis stanowiska. Nasze AI przepisze Twoje CV tak, aby pasowało — słowa kluczowe, formatowanie i struktura zoptymalizowane pod ATS.`)
};

const fi_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liitä työpaikan URL tai kuvaus. Tekoälymme kirjoittaa ansioluettelosi uudelleen vastaamaan — avainsanat, muotoilu ja rakenne ATS-optimoituna.`)
};

const da_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsæt en job-URL eller beskrivelse. Vores AI omskriver dit CV, så det matcher — nøgleord, formatering og struktur optimeret til ATS.`)
};

const sv_landing_how_step2_desc = /** @type {(inputs: Landing_How_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klistra in en jobb-URL eller beskrivning. Vår AI skriver om ditt CV för att matcha -- nyckelord, formatering och struktur optimerade för ATS.`)
};

/**
* | output |
* | --- |
* | "Paste a job URL or description. Our AI rewrites your resume to match — keywords, formatting, and structure optimized for ATS." |
*
* @param {Landing_How_Step2_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_step2_desc = /** @type {((inputs?: Landing_How_Step2_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Step2_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_step2_desc(inputs)
	if (locale === "fr") return fr_landing_how_step2_desc(inputs)
	if (locale === "es") return es_landing_how_step2_desc(inputs)
	if (locale === "it") return it_landing_how_step2_desc(inputs)
	if (locale === "nl") return nl_landing_how_step2_desc(inputs)
	if (locale === "pl") return pl_landing_how_step2_desc(inputs)
	if (locale === "fi") return fi_landing_how_step2_desc(inputs)
	if (locale === "da") return da_landing_how_step2_desc(inputs)
	if (locale === "sv") return sv_landing_how_step2_desc(inputs)
	return en_landing_how_step2_desc(inputs)
});